<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="part1"><a id="p18"></a><a id="p19"></a><span class="fsc">PART ONE</span></p>
<p class="pt">Colonial Clashes</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_01.vue?5372b60a